import { connect } from "react-redux";
import { compose } from "redux";
import Launchpad from "./Launchpad";
import { userConfigSelector, isLoggedInSelector } from "pods/auth";
import { AuthSlice } from "pods/auth";
import { appMetadataGroups as groups } from "src/pods/groups";
import { appMetadataList as list } from "src/pods/list";
import { appMetadataNoise as noise } from "src/pods/noise";
import { NuxMetadataSlice, dismissWelcomeNux, selectWelcomeDismissed } from "src/pods/nuxMetadata";
import { appMetadataPairshare as pairshare } from "src/pods/pairshare";
import { appMetadataRadio as radio } from "src/pods/radio";
import { appMetadataRandom as random } from "src/pods/random";
import { selectPaired, remoteClose } from "src/pods/realtime";
import { RealtimeState } from "src/pods/realtime";
import { appMetadataTimer as timer } from "src/pods/timer";
import { appMetadataToday as today } from "src/pods/today";
import withRouteParams from "src/shared/hoc/withRouteParams";
import React from "react";

function mapStateToProps(state: AuthSlice & RealtimeState & NuxMetadataSlice) {
  const shouldRenderWelcome =
    isLoggedInSelector(state) &&
    !selectWelcomeDismissed(state) &&
    !userConfigSelector(state)?.metaData?.toolkitWelcomeDismissed;

  return {
    paired: selectPaired(state),
    apps: [timer(), random(), groups(), noise(), list(), pairshare(), today(), radio()],
    shouldRenderWelcome,
  };
}

const mapDispatchToProps = {
  dismissWelcomeNux,
  remoteClose,
};

export default compose<React.ComponentType<any>>(
  withRouteParams(["classId", "mountPoint"]),
  connect(mapStateToProps, mapDispatchToProps),
)(Launchpad);
